/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActiveBoardResponse,
  ApiError,
  ClaimQuestRewardResponse,
  FuelUpAdminActionResponse,
  FuelUpAdminStatsResponse,
  FuelUpGameActionRequest,
  FuelUpGameActionResponse,
  FuelUpGameAdminActionRequest,
  FuelUpMoveRequest,
  FuelUpMoveResponse,
  FuelUpPrestigeActionRequest,
  FuelUpPrestigeActionResponse,
  FuelUpVaultActionRequest,
  FuelUpVaultActionResponse,
  FuelUpWheelConfigResponse,
  GasStationClaimRequest,
  GasStationClaimResponse,
  GetFuelUpGameStateResponse,
  SpinWheelRequest,
  SpinWheelResponse,
} from '../models/index';
import {
    ActiveBoardResponseFromJSON,
    ActiveBoardResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ClaimQuestRewardResponseFromJSON,
    ClaimQuestRewardResponseToJSON,
    FuelUpAdminActionResponseFromJSON,
    FuelUpAdminActionResponseToJSON,
    FuelUpAdminStatsResponseFromJSON,
    FuelUpAdminStatsResponseToJSON,
    FuelUpGameActionRequestFromJSON,
    FuelUpGameActionRequestToJSON,
    FuelUpGameActionResponseFromJSON,
    FuelUpGameActionResponseToJSON,
    FuelUpGameAdminActionRequestFromJSON,
    FuelUpGameAdminActionRequestToJSON,
    FuelUpMoveRequestFromJSON,
    FuelUpMoveRequestToJSON,
    FuelUpMoveResponseFromJSON,
    FuelUpMoveResponseToJSON,
    FuelUpPrestigeActionRequestFromJSON,
    FuelUpPrestigeActionRequestToJSON,
    FuelUpPrestigeActionResponseFromJSON,
    FuelUpPrestigeActionResponseToJSON,
    FuelUpVaultActionRequestFromJSON,
    FuelUpVaultActionRequestToJSON,
    FuelUpVaultActionResponseFromJSON,
    FuelUpVaultActionResponseToJSON,
    FuelUpWheelConfigResponseFromJSON,
    FuelUpWheelConfigResponseToJSON,
    GasStationClaimRequestFromJSON,
    GasStationClaimRequestToJSON,
    GasStationClaimResponseFromJSON,
    GasStationClaimResponseToJSON,
    GetFuelUpGameStateResponseFromJSON,
    GetFuelUpGameStateResponseToJSON,
    SpinWheelRequestFromJSON,
    SpinWheelRequestToJSON,
    SpinWheelResponseFromJSON,
    SpinWheelResponseToJSON,
} from '../models/index';

export interface CreateFuelupAdminActionRequest {
    fuelUpGameAdminActionRequest: FuelUpGameAdminActionRequest;
}

export interface CreateFuelupGameIdActionRequest {
    id: string;
    fuelUpGameActionRequest: FuelUpGameActionRequest;
}

export interface CreateFuelupGameStateIdClaimRewardRequest {
    id: string;
}

export interface CreateFuelupGameStateIdMoveRequest {
    id: string;
    fuelUpMoveRequest: FuelUpMoveRequest;
}

export interface CreateFuelupGasStationIdClaimRequest {
    id: string;
    gasStationClaimRequest: GasStationClaimRequest;
}

export interface CreateFuelupPrestigeIdActionRequest {
    id: string;
    fuelUpPrestigeActionRequest: FuelUpPrestigeActionRequest;
}

export interface CreateFuelupSpinWheelIdRequest {
    id: string;
    spinWheelRequest: SpinWheelRequest;
}

export interface CreateFuelupVaultIdActionRequest {
    id: string;
    fuelUpVaultActionRequest: FuelUpVaultActionRequest;
}

export interface GetFuelupActiveBoardRequest {
    loopLevel?: number;
}

export interface GetFuelupGameStateIdRequest {
    id: string;
}

export interface GetFuelupSpinWheelIdConfigRequest {
    id: string;
    spacePosition: number;
}

/**
 * FuelUpApi - interface
 * 
 * @export
 * @interface FuelUpApiInterface
 */
export interface FuelUpApiInterface {
    /**
     * Perform administrative actions on FuelUp Adventure
     * @param {FuelUpGameAdminActionRequest} fuelUpGameAdminActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupAdminActionRaw(requestParameters: CreateFuelupAdminActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpAdminActionResponse>>;

    /**
     * Perform administrative actions on FuelUp Adventure
     */
    createFuelupAdminAction(requestParameters: CreateFuelupAdminActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpAdminActionResponse>;

    /**
     * Perform game management actions (start, pause, resume, reset)
     * @param {string} id 
     * @param {FuelUpGameActionRequest} fuelUpGameActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupGameIdActionRaw(requestParameters: CreateFuelupGameIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpGameActionResponse>>;

    /**
     * Perform game management actions (start, pause, resume, reset)
     */
    createFuelupGameIdAction(requestParameters: CreateFuelupGameIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpGameActionResponse>;

    /**
     * Claims pending rewards from the last space landed on in Fuel-Up Adventure
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupGameStateIdClaimRewardRaw(requestParameters: CreateFuelupGameStateIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimQuestRewardResponse>>;

    /**
     * Claims pending rewards from the last space landed on in Fuel-Up Adventure
     */
    createFuelupGameStateIdClaimReward(requestParameters: CreateFuelupGameStateIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimQuestRewardResponse>;

    /**
     * Make a move in the Fuel-Up Adventure game
     * @param {string} id 
     * @param {FuelUpMoveRequest} fuelUpMoveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupGameStateIdMoveRaw(requestParameters: CreateFuelupGameStateIdMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpMoveResponse>>;

    /**
     * Make a move in the Fuel-Up Adventure game
     */
    createFuelupGameStateIdMove(requestParameters: CreateFuelupGameStateIdMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpMoveResponse>;

    /**
     * Claim gas station bonus when loading fuel
     * @param {string} id 
     * @param {GasStationClaimRequest} gasStationClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupGasStationIdClaimRaw(requestParameters: CreateFuelupGasStationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GasStationClaimResponse>>;

    /**
     * Claim gas station bonus when loading fuel
     */
    createFuelupGasStationIdClaim(requestParameters: CreateFuelupGasStationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GasStationClaimResponse>;

    /**
     * Perform a prestige action in Fuel-Up Adventure
     * @param {string} id 
     * @param {FuelUpPrestigeActionRequest} fuelUpPrestigeActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupPrestigeIdActionRaw(requestParameters: CreateFuelupPrestigeIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpPrestigeActionResponse>>;

    /**
     * Perform a prestige action in Fuel-Up Adventure
     */
    createFuelupPrestigeIdAction(requestParameters: CreateFuelupPrestigeIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpPrestigeActionResponse>;

    /**
     * Spin a wheel when landing on a spin_wheel space
     * @param {string} id 
     * @param {SpinWheelRequest} spinWheelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupSpinWheelIdRaw(requestParameters: CreateFuelupSpinWheelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinWheelResponse>>;

    /**
     * Spin a wheel when landing on a spin_wheel space
     */
    createFuelupSpinWheelId(requestParameters: CreateFuelupSpinWheelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinWheelResponse>;

    /**
     * Perform an action on the user\'s Fuel-Up vault
     * @param {string} id 
     * @param {FuelUpVaultActionRequest} fuelUpVaultActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    createFuelupVaultIdActionRaw(requestParameters: CreateFuelupVaultIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpVaultActionResponse>>;

    /**
     * Perform an action on the user\'s Fuel-Up vault
     */
    createFuelupVaultIdAction(requestParameters: CreateFuelupVaultIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpVaultActionResponse>;

    /**
     * Get the currently active Fuel-Up Adventure board for a specific loop level
     * @param {number} [loopLevel] Loop level to fetch board for (defaults to 1)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    getFuelupActiveBoardRaw(requestParameters: GetFuelupActiveBoardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveBoardResponse>>;

    /**
     * Get the currently active Fuel-Up Adventure board for a specific loop level
     */
    getFuelupActiveBoard(requestParameters: GetFuelupActiveBoardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveBoardResponse>;

    /**
     * Get comprehensive FuelUp Adventure statistics for admin dashboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    getFuelupAdminStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpAdminStatsResponse>>;

    /**
     * Get comprehensive FuelUp Adventure statistics for admin dashboard
     */
    getFuelupAdminStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpAdminStatsResponse>;

    /**
     * Get user\'s Fuel-Up Adventure game state, vault, and prestige data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    getFuelupGameStateIdRaw(requestParameters: GetFuelupGameStateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelUpGameStateResponse>>;

    /**
     * Get user\'s Fuel-Up Adventure game state, vault, and prestige data
     */
    getFuelupGameStateId(requestParameters: GetFuelupGameStateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelUpGameStateResponse>;

    /**
     * Get the wheel configuration for a specific board space
     * @param {string} id 
     * @param {number} spacePosition 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelUpApiInterface
     */
    getFuelupSpinWheelIdConfigRaw(requestParameters: GetFuelupSpinWheelIdConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpWheelConfigResponse>>;

    /**
     * Get the wheel configuration for a specific board space
     */
    getFuelupSpinWheelIdConfig(requestParameters: GetFuelupSpinWheelIdConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpWheelConfigResponse>;

}

/**
 * 
 */
export class FuelUpApi extends runtime.BaseAPI implements FuelUpApiInterface {

    /**
     * Perform administrative actions on FuelUp Adventure
     */
    async createFuelupAdminActionRaw(requestParameters: CreateFuelupAdminActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpAdminActionResponse>> {
        if (requestParameters['fuelUpGameAdminActionRequest'] == null) {
            throw new runtime.RequiredError(
                'fuelUpGameAdminActionRequest',
                'Required parameter "fuelUpGameAdminActionRequest" was null or undefined when calling createFuelupAdminAction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/admin/action`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FuelUpGameAdminActionRequestToJSON(requestParameters['fuelUpGameAdminActionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpAdminActionResponseFromJSON(jsonValue));
    }

    /**
     * Perform administrative actions on FuelUp Adventure
     */
    async createFuelupAdminAction(requestParameters: CreateFuelupAdminActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpAdminActionResponse> {
        const response = await this.createFuelupAdminActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Perform game management actions (start, pause, resume, reset)
     */
    async createFuelupGameIdActionRaw(requestParameters: CreateFuelupGameIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpGameActionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupGameIdAction().'
            );
        }

        if (requestParameters['fuelUpGameActionRequest'] == null) {
            throw new runtime.RequiredError(
                'fuelUpGameActionRequest',
                'Required parameter "fuelUpGameActionRequest" was null or undefined when calling createFuelupGameIdAction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/game/{id}/action`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FuelUpGameActionRequestToJSON(requestParameters['fuelUpGameActionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpGameActionResponseFromJSON(jsonValue));
    }

    /**
     * Perform game management actions (start, pause, resume, reset)
     */
    async createFuelupGameIdAction(requestParameters: CreateFuelupGameIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpGameActionResponse> {
        const response = await this.createFuelupGameIdActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims pending rewards from the last space landed on in Fuel-Up Adventure
     */
    async createFuelupGameStateIdClaimRewardRaw(requestParameters: CreateFuelupGameStateIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimQuestRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupGameStateIdClaimReward().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/game-state/{id}/claim-reward`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimQuestRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claims pending rewards from the last space landed on in Fuel-Up Adventure
     */
    async createFuelupGameStateIdClaimReward(requestParameters: CreateFuelupGameStateIdClaimRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimQuestRewardResponse> {
        const response = await this.createFuelupGameStateIdClaimRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Make a move in the Fuel-Up Adventure game
     */
    async createFuelupGameStateIdMoveRaw(requestParameters: CreateFuelupGameStateIdMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpMoveResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupGameStateIdMove().'
            );
        }

        if (requestParameters['fuelUpMoveRequest'] == null) {
            throw new runtime.RequiredError(
                'fuelUpMoveRequest',
                'Required parameter "fuelUpMoveRequest" was null or undefined when calling createFuelupGameStateIdMove().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/game-state/{id}/move`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FuelUpMoveRequestToJSON(requestParameters['fuelUpMoveRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpMoveResponseFromJSON(jsonValue));
    }

    /**
     * Make a move in the Fuel-Up Adventure game
     */
    async createFuelupGameStateIdMove(requestParameters: CreateFuelupGameStateIdMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpMoveResponse> {
        const response = await this.createFuelupGameStateIdMoveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claim gas station bonus when loading fuel
     */
    async createFuelupGasStationIdClaimRaw(requestParameters: CreateFuelupGasStationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GasStationClaimResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupGasStationIdClaim().'
            );
        }

        if (requestParameters['gasStationClaimRequest'] == null) {
            throw new runtime.RequiredError(
                'gasStationClaimRequest',
                'Required parameter "gasStationClaimRequest" was null or undefined when calling createFuelupGasStationIdClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/gas-station/{id}/claim`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GasStationClaimRequestToJSON(requestParameters['gasStationClaimRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GasStationClaimResponseFromJSON(jsonValue));
    }

    /**
     * Claim gas station bonus when loading fuel
     */
    async createFuelupGasStationIdClaim(requestParameters: CreateFuelupGasStationIdClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GasStationClaimResponse> {
        const response = await this.createFuelupGasStationIdClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Perform a prestige action in Fuel-Up Adventure
     */
    async createFuelupPrestigeIdActionRaw(requestParameters: CreateFuelupPrestigeIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpPrestigeActionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupPrestigeIdAction().'
            );
        }

        if (requestParameters['fuelUpPrestigeActionRequest'] == null) {
            throw new runtime.RequiredError(
                'fuelUpPrestigeActionRequest',
                'Required parameter "fuelUpPrestigeActionRequest" was null or undefined when calling createFuelupPrestigeIdAction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/prestige/{id}/action`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FuelUpPrestigeActionRequestToJSON(requestParameters['fuelUpPrestigeActionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpPrestigeActionResponseFromJSON(jsonValue));
    }

    /**
     * Perform a prestige action in Fuel-Up Adventure
     */
    async createFuelupPrestigeIdAction(requestParameters: CreateFuelupPrestigeIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpPrestigeActionResponse> {
        const response = await this.createFuelupPrestigeIdActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Spin a wheel when landing on a spin_wheel space
     */
    async createFuelupSpinWheelIdRaw(requestParameters: CreateFuelupSpinWheelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinWheelResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupSpinWheelId().'
            );
        }

        if (requestParameters['spinWheelRequest'] == null) {
            throw new runtime.RequiredError(
                'spinWheelRequest',
                'Required parameter "spinWheelRequest" was null or undefined when calling createFuelupSpinWheelId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/spin-wheel/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SpinWheelRequestToJSON(requestParameters['spinWheelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpinWheelResponseFromJSON(jsonValue));
    }

    /**
     * Spin a wheel when landing on a spin_wheel space
     */
    async createFuelupSpinWheelId(requestParameters: CreateFuelupSpinWheelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinWheelResponse> {
        const response = await this.createFuelupSpinWheelIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Perform an action on the user\'s Fuel-Up vault
     */
    async createFuelupVaultIdActionRaw(requestParameters: CreateFuelupVaultIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpVaultActionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFuelupVaultIdAction().'
            );
        }

        if (requestParameters['fuelUpVaultActionRequest'] == null) {
            throw new runtime.RequiredError(
                'fuelUpVaultActionRequest',
                'Required parameter "fuelUpVaultActionRequest" was null or undefined when calling createFuelupVaultIdAction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/vault/{id}/action`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FuelUpVaultActionRequestToJSON(requestParameters['fuelUpVaultActionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpVaultActionResponseFromJSON(jsonValue));
    }

    /**
     * Perform an action on the user\'s Fuel-Up vault
     */
    async createFuelupVaultIdAction(requestParameters: CreateFuelupVaultIdActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpVaultActionResponse> {
        const response = await this.createFuelupVaultIdActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the currently active Fuel-Up Adventure board for a specific loop level
     */
    async getFuelupActiveBoardRaw(requestParameters: GetFuelupActiveBoardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveBoardResponse>> {
        const queryParameters: any = {};

        if (requestParameters['loopLevel'] != null) {
            queryParameters['loopLevel'] = requestParameters['loopLevel'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/fuelup/active-board`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveBoardResponseFromJSON(jsonValue));
    }

    /**
     * Get the currently active Fuel-Up Adventure board for a specific loop level
     */
    async getFuelupActiveBoard(requestParameters: GetFuelupActiveBoardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveBoardResponse> {
        const response = await this.getFuelupActiveBoardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comprehensive FuelUp Adventure statistics for admin dashboard
     */
    async getFuelupAdminStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpAdminStatsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/admin/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpAdminStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get comprehensive FuelUp Adventure statistics for admin dashboard
     */
    async getFuelupAdminStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpAdminStatsResponse> {
        const response = await this.getFuelupAdminStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s Fuel-Up Adventure game state, vault, and prestige data
     */
    async getFuelupGameStateIdRaw(requestParameters: GetFuelupGameStateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelUpGameStateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFuelupGameStateId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/game-state/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFuelUpGameStateResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s Fuel-Up Adventure game state, vault, and prestige data
     */
    async getFuelupGameStateId(requestParameters: GetFuelupGameStateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelUpGameStateResponse> {
        const response = await this.getFuelupGameStateIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the wheel configuration for a specific board space
     */
    async getFuelupSpinWheelIdConfigRaw(requestParameters: GetFuelupSpinWheelIdConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelUpWheelConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFuelupSpinWheelIdConfig().'
            );
        }

        if (requestParameters['spacePosition'] == null) {
            throw new runtime.RequiredError(
                'spacePosition',
                'Required parameter "spacePosition" was null or undefined when calling getFuelupSpinWheelIdConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['spacePosition'] != null) {
            queryParameters['spacePosition'] = requestParameters['spacePosition'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/fuelup/spin-wheel/{id}/config`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelUpWheelConfigResponseFromJSON(jsonValue));
    }

    /**
     * Get the wheel configuration for a specific board space
     */
    async getFuelupSpinWheelIdConfig(requestParameters: GetFuelupSpinWheelIdConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelUpWheelConfigResponse> {
        const response = await this.getFuelupSpinWheelIdConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
